import React from 'react';
import PropTypes from 'prop-types';
import css from './SearchButton.css';
import MaterialIcon from 'SF/MaterialIcon';

export default class SearchButton extends React.Component {

  render() {
    return (
      <div
      	className={css['button']}
      	onClick={this.props.onClick}
      	aria-label="Open search for students"
      	role="button"
      	tabIndex="0">
        <MaterialIcon icon='search' />
      </div>
    );
  }
}

SearchButton.propTypes = {
  onClick: PropTypes.func.isRequired
};
